// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"453":"78e3199c","667":"c5341834","977":"b7afffc5"}[chunkId] + ".chunk.js");